import React from 'react';
import classNames from 'classnames';
import styles from '~/components/molecules/settings/settings.module.scss';
import Sort from '~/components/molecules/sort/sort';
import helperStyle from '~/components/styles/helpers.module.scss';
import { useRenderingInfo } from '~/contexts/useRenderingInfo';
import { SelectedSort, SortingMethods } from '~/core/features/sorting/types/sorting.type';
import { useSERPState } from '~/core/state/SERPStateContext';
import ResultLayout from '../resultLayout/resultLayout';
import { useResultsCountMessage } from './resultsCountMessage';

export type ChunkType = boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;

interface ISettings {
    productCurrentCount: number;
    productTotalCount: number;
    selectedSort: SelectedSort;
    sortingMethods: SortingMethods;
    categoryResultsCount: number;
    sortResults: (selectedSort: SelectedSort) => void;
}

const Settings: React.FC<ISettings> = ({
    productCurrentCount,
    productTotalCount,
    selectedSort,
    sortingMethods,
    categoryResultsCount,
    sortResults,
}) => {
    const overviewMessage = useResultsCountMessage({ productCurrentCount, productTotalCount });
    const { isMobileVersion, isBigDesktop } = useRenderingInfo();
    const state = useSERPState();

    return (
        <div className={styles.serpSettings} data-testid="products-settings">
            <div
                role="paragraph"
                className={classNames({ [styles.serpSettingsCount]: true, [helperStyle.textSmall]: true })}
            >
                {(!isMobileVersion || categoryResultsCount > 0) && (
                    <span
                        dangerouslySetInnerHTML={{ __html: overviewMessage }}
                        data-testid="products-search-overview"
                    ></span>
                )}
            </div>
            <div className={styles.serpSettingsOptions}>
                {sortingMethods.length > 0 ? (
                    <Sort selectedSort={selectedSort} sortingMethods={sortingMethods} sortResults={sortResults} />
                ) : null}
                {isBigDesktop && state.showLayoutSwitcher && <ResultLayout />}
            </div>
        </div>
    );
};

export default Settings;
